if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.viewer = this.querySelector('[id^="GalleryViewer"]');
        this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        this.onThumbnailClick = this.onThumbnailClick.bind(this);

        if (this.thumbnails) {
          this.thumbnails.addEventListener('click', this.onThumbnailClick);
        }
      }

      onThumbnailClick(event) {
        const button = event.target.closest('button.thumbnail');
        if (!button) return;

        const thumbnailItem = button.closest('[data-target]');
        if (!thumbnailItem) return;

        event.preventDefault();
        this.setActiveMedia(thumbnailItem.dataset.target, false);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        if (typeof pauseAllMedia === 'function') pauseAllMedia();

        this.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend && activeMedia.parentElement?.firstElementChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);
          this.viewer?.querySelector('slider-component')?.resetPages?.();
        }

        this.scrollToActiveMedia(activeMedia);
        this.setActiveThumbnail(mediaId);
      }

      scrollToActiveMedia(activeMedia) {
        if (!this.viewer) return;

        const scrollTarget = activeMedia.offsetLeft;
        const slider = this.viewer.querySelector('[id^="Slider-Gallery"]');

        if (slider) {
          slider.scrollTo({ left: scrollTarget, behavior: 'smooth' });
          return;
        }

        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      setActiveThumbnail(mediaId) {
        if (!this.thumbnails) return;

        this.thumbnails.querySelectorAll('button.thumbnail[aria-current="true"]').forEach((button) => {
          button.removeAttribute('aria-current');
        });

        const activeThumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"] button.thumbnail`);
        if (!activeThumbnail) return;

        activeThumbnail.setAttribute('aria-current', true);
        activeThumbnail.focus({ preventScroll: true });
      }
    }
  );
}
